import React from 'react'
import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import MenuBar from "./MenuBar";
import { Nav, NavDropdown } from "react-bootstrap";
import "../../external.css"
import { useDispatch } from "react-redux";
import { openPopup } from "../../store/popupSlice";
import GoogleTranslate from "./GoogleTranslate";
// import GoogleTranslate from "./GoogleTranslate"

export const Header = () => {
  const dispatch = useDispatch();

  const [isSticky, setIsSticky] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isIndustryHovered, setIsIndustryHovered] = useState(false);
  const [isFeatureHovered, setIsFeatureHovered] = useState(false);
  const [isCloneHovered, setIsCloneHovered] = useState(false);

  const handleMouseEnter = useCallback(() => { setIsHovered(true); }, []);
  const handleIndustryMouseEnter = useCallback(() => { setIsIndustryHovered(true); }, []);
  const handleFeatureMouseEnter = useCallback(() => { setIsFeatureHovered(true); }, []);
  const handleCloneMouseEnter = useCallback(() => { setIsCloneHovered(true); }, []);

  const handleMouseLeave = useCallback(() => { setIsHovered(false); }, []);
  const handleIndustryMouseLeave = useCallback(() => { setIsIndustryHovered(false); }, []);
  const handleFeatureMouseLeave = useCallback(() => { setIsFeatureHovered(false); }, []);
  const handleCloneMouseLeave = useCallback(() => { setIsCloneHovered(false); }, []);

  const handleToggleMenu = useCallback(() => { setIsOpen((prev) => !prev); }, []);
  const handleScroll = useCallback(() => {
    if (typeof window !== "undefined") {
      setIsSticky(window.scrollY > 0);
    }
  }, []);

  const handleLinkClick = useCallback(() => {
    setIsHovered(false);
    setIsIndustryHovered(false);
    setIsFeatureHovered(false);
  }, []);



  useEffect(() => {
    if (typeof window === "undefined") return;
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);

  return (
    <>
      {/* <section className="black-friday-strip">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="black-friday-stripwrap">
                <span >Black Friday Mega Sale - Grab Upto 30% Off</span>
                <Link onClick={() => dispatch(openPopup())} className="default-btn">
                  unlock your discount
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <div className={`header-area ${isSticky ? "stick" : ""}`}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-5 col-lg-2 col-md-3">
              <div className="logo">
                <Link to={"/"}><img width={140} height={54} src="/assets/Logo1.webp" alt="Logo" className="img-responsive" /></Link>
              </div>
            </div>

            <div className="col-7 col-lg-10 col-md-9">
              <nav className="header-menubar">
                <ul className="header-menulink">

                  {/*============= Solutions Menu Start ==============*/}
                  <li onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                    <NavDropdown id="nav-dropdown-dark-example" title="SOLUTIONS" menuVariant="light" show={isHovered} >
                      <div className="solution-bigmenu">
                        <div className="solution-menubox">
                          <img src="/assets/home/menudrop-icon1.webp" alt="icon" loading="lazy" />
                          <div>
                            <Link to="/shuttle-software" onClick={handleLinkClick}>Shuttle Software</Link>
                            <p>Manage and streamline your shuttle services with ease.</p>
                          </div>
                        </div>

                        <div className="solution-menubox">
                          <img src="/assets/home/menudrop-icon2.webp" alt="icon" loading="lazy" />
                          <div>
                            <Link to="/car-rental-software" onClick={handleLinkClick}>Car Rental Software</Link>
                            <p>Efficiently handle rentals and reservations for your fleet.</p>
                          </div>
                        </div>

                        <div className="solution-menubox">
                          <img src="/assets/home/menudrop-icon3.webp" alt="icon" loading="lazy" />
                          <div>
                            <Link to="/best-taxi-dispatch-software" onClick={handleLinkClick}>Taxi Dispatch Software</Link>
                            <p>Optimize dispatching and improve taxi service management.</p>
                          </div>
                        </div>

                        <div className="solution-menubox">
                          <img src="/assets/home/menudrop-icon5.webp" alt="icon" loading="lazy" />
                          <div>
                            <Link to="/white-label-solutions" onClick={handleLinkClick}>White Label Solutions</Link>
                            <p>Customize software to match your brand and business needs.</p>
                          </div>
                        </div>

                        <div className="solution-menubox">
                          <img src="/assets/home/menudrop-icon4.webp" alt="icon" loading="lazy" />
                          <div>
                            <Link to="/white-lable-carpool-app-dispatch-software" onClick={handleLinkClick}>Carpool & Rideshare Software</Link>
                            <p>Enable smooth and efficient carpool and rideshare solutions.</p>
                          </div>
                        </div>

                        <div className="solution-menubox">
                          <img src="/assets/home/menudrop-icon-bike.webp" alt="icon" loading="lazy" />
                          <div>
                            <Link to="/bike-rental" onClick={handleLinkClick}>Bike Rental Software</Link>
                            <p>Efficiently manage and scale your bike-sharing services with ease.</p>
                          </div>
                        </div>

                        <div className="solution-menubox">
                          <img src="/assets/home/menudrop-icon-airport.webp" alt="icon" loading="lazy" />
                          <div>
                            <Link to="/airport-transfer-software" onClick={handleLinkClick}>Airport transfer software</Link>
                            <p>Future proof your taxi operations to compete in this digital age.</p>
                          </div>
                        </div>

                        <div className="solution-menubox">
                          <img src="/assets/home/menudrop-icon-custom-app.webp" alt="icon" loading="lazy" />
                          <div>
                            <Link to={"/custom-app-development"} onClick={handleLinkClick}>custom app development</Link>
                            <p>Boost your business with a custom app designed for the digital age.</p>
                          </div>
                        </div>

                        <div className="solution-menubox">
                          <img src="/assets/home/menudrop-icon-web-app.webp" alt="icon" loading="lazy" />
                          <div>
                            <Link to="/web-app-development" onClick={handleLinkClick}>web app development</Link>
                            <p>The web app to take your business to an escalated extent.</p>
                          </div>
                        </div>

                        <div className="solution-menubox">
                          <img src="/assets/home/menudrop-icon-ondemand2.webp" alt="icon" loading="lazy" />
                          <div>
                            <Link to="/on-demand-delivery-app" onClick={handleLinkClick}>On-Demand Delivery App</Link>
                            <p>End-to-End On-Demand Solutions Designed for Growth</p>
                          </div>
                        </div>

                        <div className="solution-menubox">
                          <img src="/assets/home/menudrop-icon-busmanage.webp" alt="icon" loading="lazy" />
                          <div>
                            <Link to="/bus-management-software" onClick={handleLinkClick}>bus management software</Link>
                            <p>Streamline Routes, Track Buses, Simplify Fleet Management</p>
                          </div>
                        </div>

                        <div className="solution-menubox">
                          <img src="/assets/home/menudrop-icon-limo.webp" alt="icon" loading="lazy" />
                          <div>
                            <Link to="/best-limo-booking-software" onClick={handleLinkClick}>limo booking software</Link>
                            <p>Effortless Reservations, Real-Time Tracking, Premium Service</p>
                          </div>
                        </div>
                      </div>

                      {/* <NavDropdown.Item>
                        <img src="./assets/home/menudrop-icon1.webp" alt="icon"/> 
                        <Link to="shuttle-software">Shuttle Software</Link>
                      </NavDropdown.Item>

                      <NavDropdown.Item>
                        <img src="./assets/home/menudrop-icon2.webp" alt="icon"/> 
                        <Link to="car-rental-software">Car Rental Software</Link>
                      </NavDropdown.Item>

                      <NavDropdown.Item>
                        <img src="./assets/home/menudrop-icon3.webp" alt="icon"/> 
                        <Link to="/best-taxi-dispatch-software">Taxi Dispatch Software</Link>
                      </NavDropdown.Item>

                      <NavDropdown.Item>
                        <img src="./assets/home/menudrop-icon4.webp" alt="icon"/> 
                        <Link to="/white-lable-carpool-app-dispatch-software">Carpool & Rideshare Software</Link>
                      </NavDropdown.Item>

                      <NavDropdown.Item>
                        <img src="./assets/home/menudrop-icon5.webp" alt="icon"/> 
                        <Link to="/white-label-solutions">White Label Solutions</Link>
                      </NavDropdown.Item> */}
                    </NavDropdown>
                  </li>
                  {/*============= Solutions Menu End ================*/}

                  {/*============= Industry Menu Start ===============*/}
                  <li onMouseEnter={handleIndustryMouseEnter} onMouseLeave={handleIndustryMouseLeave}>
                    <NavDropdown id="nav-dropdown-dark-example" title="INDUSTRIES" menuVariant="light" show={isIndustryHovered}>
                      <div className="industry-menu-scroll">
                        <div className="solution-bigmenu industries-menu-wrap">

                          <div className="industries-big-menu">
                            <h4>on demand</h4>

                            <div className="solution-menubox">
                              <img src="/assets/home/menudrop-icon-food.webp" alt="icon" loading="lazy" />
                              <div>
                                <Link to="/food-grocery-delivery-app-development-company" onClick={handleLinkClick}>food delivery</Link>
                              </div>
                            </div>

                            <div className="solution-menubox">
                              <img src="/assets/home/menudrop-icon-grocery.webp" alt="icon" loading="lazy" />
                              <div>
                                <Link to="/food-grocery-delivery-app-development-company" onClick={handleLinkClick}>grocery delivery</Link>
                              </div>
                            </div>

                            <div className="solution-menubox">
                              <img src="/assets/home/menudrop-icon-ecom.webp" alt="icon" loading="lazy" />
                              <div>
                                <Link to="/ecommerce-mobile-app-development-company" onClick={handleLinkClick}>E-Commerce delivery</Link>
                              </div>
                            </div>

                            <div className="solution-menubox">
                              <img src="/assets/home/menudrop-icon-restr.webp" alt="icon" />
                              <div>
                                <Link to="/restaurant-app-development-company" onClick={handleLinkClick}>restaurant app</Link>
                              </div>
                            </div>

                            <div className="solution-menubox">
                              <img src="/assets/home/menudrop-icon-pharm.webp" alt="icon" loading="lazy" />
                              <div>
                                <Link to="/best-pharmacy-app-development-company" onClick={handleLinkClick}>pharmacy delivery</Link>
                              </div>
                            </div>



                            {/*<div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-pickup.webp" alt="icon"/> 
                                <div>
                                    <Link to="/coming-soon" onClick={handleLinkClick}>pickup delivery</Link>
                                </div>
                            </div>*/}
                          </div>

                          <div className="industries-big-menu">
                            <h4>services</h4>
                            <div className="solution-menubox">
                              <img src="/assets/home/menudrop-icon-taxi.webp" alt="icon" loading="lazy" />
                              <div>
                                <Link to="/best-taxi-dispatch-software" onClick={handleLinkClick}>taxi & transportation</Link>
                              </div>
                            </div>

                            <div className="solution-menubox">
                              <img src="/assets/home/menudrop-icon-airport1.webp" alt="icon" loading="lazy" />
                              <div>
                                <Link to="/airport-transfer-software" onClick={handleLinkClick}>Airport Taxi</Link>
                              </div>
                            </div>

                            <div className="solution-menubox">
                              <img src="/assets/home/menudrop-icon-shuttle.webp" alt="icon" loading="lazy" />
                              <div>
                                <Link to="/shuttle-software" onClick={handleLinkClick}>shuttle services</Link>
                              </div>
                            </div>

                            {/* <div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-carpool.webp" alt="icon"/> 
                                <div>
                                    <Link to="/white-lable-carpool-app-dispatch-software" onClick={handleLinkClick}>car pooling</Link>
                                </div>
                            </div>  */}

                            <div className="solution-menubox">
                              <img src="/assets/home/menudrop-icon-bikerent.webp" alt="icon" loading="lazy" />
                              <div>
                                <Link to="/bike-rental" onClick={handleLinkClick}>bike rental</Link>
                              </div>
                            </div>

                            {/*<div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-Concierge.webp" alt="icon"/> 
                                <div>
                                    <Link to="/coming-soon" onClick={handleLinkClick}>Concierge</Link>
                                  </div>
                            </div>*/}

                          </div>

                          <div className="industries-big-menu">
                            <h4>others</h4>

                            <div className="solution-menubox">
                              <img src="/assets/home/menudrop-icon-logistic.webp" alt="icon" loading="lazy" />
                              <div>
                                <a target='_blank' href={"https://www.mobilityinfotechlogistics.com/"} onClick={handleLinkClick}>Logistics</a>
                              </div>
                            </div>

                            {/*<div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-foodgrocery.webp" alt="icon"/> 
                                <div>
                                    <Link to="/food-and-grocery-app" onClick={handleLinkClick}>food & grocery</Link>
                                  </div>
                            </div>*/}

                            {/*<div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-mobility.webp" alt="icon"/> 
                                <div>
                                    <Link to="/coming-soon" onClick={handleLinkClick}>mobility</Link>
                                  </div>
                            </div>*/}

                            <div className="solution-menubox">
                              <img src="/assets/home/menudrop-icon-health.webp" alt="icon" loading="lazy" />
                              <div>
                                <Link to="/custom-healthcare-app-development-services" onClick={handleLinkClick}>Healthcare</Link>
                              </div>
                            </div>

                            <div className="solution-menubox">
                              <img src="/assets/home/menudrop-icon-education.webp" alt="icon" />
                              <div>
                                <Link to="/education-app-development-services" onClick={handleLinkClick}>education</Link>
                              </div>
                            </div>

                            <div className="solution-menubox">
                              <img src="/assets/home/menudrop-icon-telemedicine.webp" alt="icon" />
                              <div>
                                <Link to="/telemedicine-app-development-company" onClick={handleLinkClick}>telemedicine</Link>
                              </div>
                            </div>

                            {/*<div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-fitness.webp" alt="icon"/> 
                                <div>
                                    <Link to="/coming-soon" onClick={handleLinkClick}>fitness</Link>
                                  </div>
                            </div>*/}
                          </div>

                          <div className="industries-big-menu">
                            <h4>marketplace</h4>

                            {/*<div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-service.webp" alt="icon"/> 
                                <div>
                                    <Link to="/coming-soon" onClick={handleLinkClick}>service</Link>
                                </div>
                            </div>*/}

                            <div className="solution-menubox">
                              <img src="/assets/home/menudrop-icon-rental.webp" alt="icon" loading="lazy" />
                              <div>
                                <Link to="/car-rental-software" onClick={handleLinkClick}>Car Rental</Link>
                              </div>
                            </div>

                            {/*<div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-freelance.webp" alt="icon"/> 
                                <div>
                                    <Link to="/coming-soon" onClick={handleLinkClick}>freelancer</Link>
                                </div>
                            </div>*/}

                            <div className="solution-menubox">
                              <img src="/assets/home/menudrop-icon-ecom1.webp" alt="icon" loading="lazy" />
                              <div>
                                <Link to="/ecommerce-mobile-app-development-company" onClick={handleLinkClick}>e-commerce</Link>
                              </div>
                            </div>

                            {/*<div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-peer.webp" alt="icon"/> 
                                <div>
                                    <Link to="/coming-soon" onClick={handleLinkClick}>peer to peer</Link>
                                </div>
                            </div>

                            <div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-fintech.webp" alt="icon"/> 
                                <div>
                                    <Link to="/coming-soon" onClick={handleLinkClick}>fintech</Link>
                                </div>
                            </div>*/}

                          </div>

                          <div className="industries-big-menu">
                            <h4>solutions</h4>

                            {/*<div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-ondemand.webp" alt="icon"/> 
                                <div>
                                    <Link to="/coming-soon" onClick={handleLinkClick}>on demand app</Link>
                                </div>
                            </div> */}

                            <div className="solution-menubox">
                              <img src="/assets/home/menudrop-icon-carpoolshare.webp" alt="icon" loading="lazy" />
                              <div>
                                <Link to="/white-lable-carpool-app-dispatch-software" onClick={handleLinkClick}>Carpool & ride sharing app</Link>
                              </div>
                            </div>

                            <div className="solution-menubox">
                              <img src="/assets/home/menudrop-icon-whitelabel1.webp" alt="icon" loading="lazy" />
                              <div>
                                <Link to="/white-label-solutions" onClick={handleLinkClick}>white label solutions</Link>
                              </div>
                            </div>


                            {/*<div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-consult.webp" alt="icon"/> 
                                <div>
                                    <Link to="/coming-soon" onClick={handleLinkClick}>consultation app</Link>
                                </div>
                            </div> */}

                            {/*<div className="solution-menubox">
                                <img src="/assets/home/menudrop-icon-dating.webp" alt="icon"/> 
                                <div>
                                    <Link to="/coming-soon" onClick={handleLinkClick}>dating app</Link>
                                </div>
                            </div>*/}


                          </div>
                        </div>

                        <div className="industry-menu-exclusive">
                          <Link to={"/white-label-solutions"}>
                            <div className="exclusive-btn">
                              <div>
                                <span><span>exclusive</span></span>
                                <label>Custom White Lable Solutions <p>(All-in-one App Solution)</p></label>
                              </div>
                              <span className="exclusive-btn-togo">explore</span>
                            </div>
                          </Link>
                          <div className="bookdemo-industry-menu">
                            <Link onClick={() => dispatch(openPopup())} to={""}>BOOK FREE DEMO</Link>
                          </div>
                        </div>
                      </div>
                    </NavDropdown>
                  </li>
                  {/*============= Industry Menu End =================*/}

                  {/*============= Clone Apps Menu Start =============*/}
                  {/* <li onMouseEnter={handleCloneMouseEnter} onMouseLeave={handleCloneMouseLeave}>
                    <NavDropdown id="nav-dropdown-dark-example" title="clone apps" menuVariant="light" show={isCloneHovered} >
                      <div className="industry-menu-scroll">
                        <div className="solution-bigmenu industries-menu-wrap">

                          <div className="industries-big-menu">
                            <h4>Taxi Apps</h4>
                            <div className="solution-menubox">
                              <img src="/assets/home/clone-header-icon1.webp" alt="clone-apps" className="img-responsive" />
                              <div>
                                <Link to="/clone-app/lyft-clone-app" onClick={handleLinkClick}>Lyft clone</Link>
                              </div>
                            </div>
                            <div className="solution-menubox">
                              <img src="/assets/home/clone-header-icon2.webp" alt="clone-apps" className="img-responsive" />
                              <div>
                                <Link to="/clone-app/uber-clone-app" onClick={handleLinkClick}>Uber clone</Link>
                              </div>
                            </div>
                            <div className="solution-menubox">
                              <img src="/assets/home/clone-header-icon3.webp" alt="clone-apps" className="img-responsive" />
                              <div>
                                <Link to="/clone-app/bolt-clone-app" onClick={handleLinkClick}>bolt clone</Link>
                              </div>
                            </div>
                            <div className="solution-menubox">
                              <img src="/assets/home/clone-header-icon4.webp" alt="clone-apps" className="img-responsive" />
                              <div>
                                <Link to="/clone-app/mai-linh-clone-app" onClick={handleLinkClick}>mai linh clone</Link>
                              </div>
                            </div>
                            <div className="solution-menubox">
                              <img src="/assets/home/clone-header-icon5.webp" alt="clone-apps" className="img-responsive" />
                              <div>
                                <Link to="/clone-app/yellow-cab-clone-app" onClick={handleLinkClick}>yellow cab clone</Link>
                              </div>
                            </div>
                            <div className="solution-menubox">
                              <img src="/assets/home/clone-header-icon6.webp" alt="clone-apps" className="img-responsive" />
                              <div>
                                <Link to="/clone-app/uride-clone-app" onClick={handleLinkClick}>uride clone</Link>
                              </div>
                            </div>
                            <div className="solution-menubox">
                              <img src="/assets/home/clone-header-icon7.webp" alt="clone-apps" className="img-responsive" />
                              <div>
                                <Link to="/clone-app/easy-taxi-clone-app" onClick={handleLinkClick}>easy taxi clone</Link>
                              </div>
                            </div>
                          </div>

                          <div className="industries-big-menu">
                            <h4>Taxi Apps</h4>
                            <div className="solution-menubox">
                              <img src="/assets/home/clone-header-icon7.webp" alt="clone-apps" className="img-responsive" />
                              <div>
                                <Link to="/clone-app/grab-clone-app" onClick={handleLinkClick}>grab clone</Link>
                              </div>
                            </div>
                            <div className="solution-menubox">
                              <img src="/assets/home/clone-header-icon6.webp" alt="clone-apps" className="img-responsive" />
                              <div>
                                <Link to="/clone-app/ola-clone-app" onClick={handleLinkClick}>Ola clone</Link>
                              </div>
                            </div>
                            <div className="solution-menubox">
                              <img src="/assets/home/clone-header-icon4.webp" alt="clone-apps" className="img-responsive" />
                              <div>
                                <Link to="/clone-app/zoom-zoom-clone-app" onClick={handleLinkClick}>zoom zoom clone</Link>
                              </div>
                            </div>
                            <div className="solution-menubox">
                              <img src="/assets/home/clone-header-icon5.webp" alt="clone-apps" className="img-responsive" />
                              <div>
                                <Link to="/clone-app/blue-smart-clone-app" onClick={handleLinkClick}>Blue Smart clone</Link>
                              </div>
                            </div>
                            <div className="solution-menubox">
                              <img src="/assets/home/clone-header-icon3.webp" alt="clone-apps" className="img-responsive" />
                              <div>
                                <Link to="/clone-app/va-de-taxi-clone-app" onClick={handleLinkClick}>Vá de Táxi clone</Link>
                              </div>
                            </div>
                            <div className="solution-menubox">
                              <img src="/assets/home/clone-header-icon2.webp" alt="clone-apps" className="img-responsive" />
                              <div>
                                <Link to="/clone-app/99taxis-clone-app" onClick={handleLinkClick}>99taxis clone</Link>
                              </div>
                            </div>

                            <div className="solution-menubox">
                              <img src="/assets/home/clone-header-icon1.webp" alt="clone-apps" className="img-responsive" />
                              <div>
                                <Link to="/clone-app/free-now-clone-app" onClick={handleLinkClick}>free now clone</Link>
                              </div>
                            </div>
                          </div>

                          <div className="industries-big-menu">
                            <h4>Grocery Apps</h4>
                            <div className="solution-menubox">
                              <img src="/assets/home/clone-header-grocery-icon1.webp" alt="clone-apps" className="img-responsive" />
                              <div>
                                <Link to="/clone-app/uber-eats-clone-app" onClick={handleLinkClick}>Uber Eats Clone</Link>
                              </div>
                            </div>
                            <div className="solution-menubox">
                              <img src="/assets/home/clone-header-grocery-icon2.webp" alt="clone-apps" className="img-responsive" />
                              <div>
                                <Link to="/clone-app/blinkit-clone-app" onClick={handleLinkClick}>BlinkIt clone</Link>
                              </div>
                            </div>
                            <div className="solution-menubox">
                              <img src="/assets/home/clone-header-grocery-icon3.webp" alt="clone-apps" className="img-responsive" />
                              <div>
                                <Link to="/clone-app/swiggy-clone-app" onClick={handleLinkClick}>Swiggy clone</Link>
                              </div>
                            </div>
                            <div className="solution-menubox">
                              <img src="/assets/home/clone-header-grocery-icon4.webp" alt="clone-apps" className="img-responsive" />
                              <div>
                                <Link to="/clone-app/bigbasket-clone-app" onClick={handleLinkClick}>Bigbasket clone</Link>
                              </div>
                            </div>
                            <div className="solution-menubox">
                              <img src="/assets/home/clone-header-grocery-icon5.webp" alt="clone-apps" className="img-responsive" />
                              <div>
                                <Link to="/clone-app/deliveroo-clone-app" onClick={handleLinkClick}>deliveroo Clone</Link>
                              </div>
                            </div>
                            <div className="solution-menubox">
                              <img src="/assets/home/clone-header-grocery-icon6.webp" alt="clone-apps" className="img-responsive" />
                              <div>
                                <Link to="/clone-app/freshdirect-clone-app" onClick={handleLinkClick}>FreshDirect clone</Link>
                              </div>
                            </div>
                            <div className="solution-menubox">
                              <img src="/assets/home/clone-header-grocery-icon7.webp" alt="clone-apps" className="img-responsive" />
                              <div>
                                <Link to="/clone-app/doordash-clone-app" onClick={handleLinkClick}>doordash clone</Link>
                              </div>
                            </div>
                          </div>

                          <div className="industries-big-menu">
                            <h4>Carpool Apps</h4>
                            <div className="solution-menubox">
                              <img src="/assets/home/clone-header-pool-icon1.webp" alt="clone-apps" className="img-responsive" />
                              <div>
                                <Link to="/clone-app/blabla-car-clone-app" onClick={handleLinkClick}>blabla clone</Link>
                              </div>
                            </div>
                            <div className="solution-menubox">
                              <img src="/assets/home/clone-header-pool-icon2.webp" alt="clone-apps" className="img-responsive" />
                              <div>
                                <Link to="/clone-app/blabla-car-clone-app-italy" onClick={handleLinkClick}>blabla clone Italy</Link>
                              </div>
                            </div>
                            <div className="solution-menubox">
                              <img src="/assets/home/clone-header-pool-icon3.webp" alt="clone-apps" className="img-responsive" />
                              <div>
                                <Link to="/clone-app/cabify-clone-app" onClick={handleLinkClick}>cabify clone</Link>
                              </div>
                            </div>
                            <div className="solution-menubox">
                              <img src="/assets/home/clone-header-pool-icon4.webp" alt="clone-apps" className="img-responsive" />
                              <div>
                                <Link to="/clone-app/poparide-clone-app" onClick={handleLinkClick}>poparide clone</Link>
                              </div>
                            </div>
                            <div className="solution-menubox">
                              <img src="/assets/home/clone-header-pool-icon5.webp" alt="clone-apps" className="img-responsive" />
                              <div>
                                <Link to="/clone-app/zipcar-clone-app" onClick={handleLinkClick}>zipcar clone</Link>
                              </div>
                            </div>
                            <div className="solution-menubox">
                              <img src="/assets/home/clone-header-pool-icon6.webp" alt="clone-apps" className="img-responsive" />
                              <div>
                                <Link to="/clone-app/xanh-sm-clone-app" onClick={handleLinkClick}>xanh sm clone</Link>
                              </div>
                            </div>
                          </div>

                          <div className="industries-big-menu">
                            <h4>Super Apps</h4>
                            <div className="solution-menubox">
                              <img src="/assets/home/clone-header-super-icon1.webp" alt="clone-apps" className="img-responsive" />
                              <div>
                                <Link to="/clone-app/careem-clone-app" onClick={handleLinkClick}>Careem clone</Link>
                              </div>
                            </div>
                            <div className="solution-menubox">
                              <img src="/assets/home/clone-header-super-icon2.webp" alt="clone-apps" className="img-responsive" />
                              <div>
                                <Link to="/clone-app/grocery-clone-app" onClick={handleLinkClick}>grocery clone</Link>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="industry-menu-exclusive">
                          <Link to={"/white-label-solutions"}>
                            <div className="exclusive-btn">
                              <div>
                                <span><span>exclusive</span></span>
                                <label>Custom White Lable Solutions <p>(All-in-one App Solution)</p></label>
                              </div>
                              <span className="exclusive-btn-togo">explore</span>
                            </div>
                          </Link>
                          <div className="bookdemo-industry-menu">
                            <Link onClick={() => dispatch(openPopup())} to={""}>BOOK FREE DEMO</Link>
                          </div>
                        </div>
                      </div>
                    </NavDropdown>
                  </li> */}


                  <li onMouseEnter={handleFeatureMouseEnter} onMouseLeave={handleFeatureMouseLeave}>
                    <NavDropdown id="nav-dropdown-dark-example" className="feature-drop" title="FEATURE" menuVariant="light" show={isFeatureHovered} >
                      <div className="solution-bigmenu">
                        <div className="solution-menubox">
                          <div>
                            <Link to="/features/taxi-software" onClick={handleLinkClick}>Taxi Software</Link>
                          </div>
                        </div>
                      </div>
                    </NavDropdown>
                  </li>

                  {/* <li><Link to={"/about"}>Company</Link></li> */}
                  <li><Link to={"/pricing"}>Pricing</Link></li>
                  <li><Link to={"/case-study"}>Case Study</Link></li>
                </ul>

                <Link to={"/contact"} className="header-butn">Contact Us</Link>

                {/* <GoogleTranslate/> */}

                <div className="btn1" onClick={handleToggleMenu}>
                  <div className="menu-line icon-top"></div>
                  <div className="menu-line icon-center"></div>
                  <div className="menu-line icon-bottom"></div>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <MenuBar isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  );
};
